import React, { Component, PropTypes } from 'react';
import './Step.css';


class Step extends Component {
  render() {
    return (
      <p className={this.props.isActive ? "step step__active" : "step"}>
        {this.props.text}
      </p>
    );
  }
}

Step.propTypes = {
  isActive: PropTypes.bool.isRequired
};

export default Step;



/** WEBPACK FOOTER **
 ** ./src/components/Step/index.js
 **/